type ChartPaletteRefreshJob = () => void | Promise<void>;

const jobsByToken = new Map<symbol, ChartPaletteRefreshJob>();
const queueOrder: Array<symbol> = [];
let flushScheduled = false;

function scheduleFlush (): void {
    if (flushScheduled) return;
    flushScheduled = true;
    requestAnimationFrame(() => {
        flushNext().catch(() => {});
    });
}

async function flushNext (): Promise<void> {
    flushScheduled = false;
    const token = queueOrder.shift();
    if (token === undefined) return;

    const job = jobsByToken.get(token);
    jobsByToken.delete(token);
    if (job) {
        await job();
    }

    if (queueOrder.length > 0) {
        scheduleFlush();
    }
}

function enqueueChartPaletteRefresh (token: symbol, job: ChartPaletteRefreshJob): void {
    jobsByToken.set(token, job);
    if (!queueOrder.includes(token)) {
        queueOrder.push(token);
    }
    scheduleFlush();
}

function cancelChartPaletteRefresh (token: symbol): void {
    jobsByToken.delete(token);
    const index = queueOrder.indexOf(token);
    if (index !== -1) {
        queueOrder.splice(index, 1);
    }
}

async function flushChartPaletteRefreshQueueForTests (): Promise<void> {
    flushScheduled = false;
    while (queueOrder.length > 0) {
        await flushNext();
    }
}

function resetChartPaletteRefreshQueueForTests (): void {
    jobsByToken.clear();
    queueOrder.length = 0;
    flushScheduled = false;
}

export {
    enqueueChartPaletteRefresh,
    cancelChartPaletteRefresh,
    flushChartPaletteRefreshQueueForTests,
    resetChartPaletteRefreshQueueForTests,
};
